import React from "react";
import passwordrestored from "../../images/password-restored.svg";
import LoginLayout from "./LoginLayout";
import { useHistory } from "react-router-dom";

const PasswordRestored = () => {
  const history = useHistory();

  return (
    <LoginLayout>
      <div className="login-cover">
        <div className="login-box password-restored">
          <h2>Great! Your password has been restored</h2>
          {/* <div className="left-arrow">
                    <img src={arrow} alt="arrow" />
                </div> */}
          <div className="restore-password-img">
            <img src={passwordrestored} alt="restore-password" />
          </div>
          <form className="login-form">
            <div className="form-submit">
              <input
                onClick={() => history.push("/login")}
                type="button"
                className="submit-btn"
                value="Login"
              />
            </div>
          </form>
        </div>
      </div>
    </LoginLayout>
  );
};

export default PasswordRestored;
